module.exports = __webpack_public_path__ + "img/finance-application-display-lincoln.ffde874b.png";